module.exports = __webpack_public_path__ + "media/images/vector-3@2x-e0fc5d313198eb8deb7169ed8ad808be.png";